import axiosInstance from './axiosInstance'
import CouponApiData from '../types/CouponApiData'

const getAllCoupons = () => {
  return axiosInstance.get(`/api/coupon/list`)
}

const createCoupon = ({
  title,
  code,
  appleCouponCode,
  googleCouponCode,
  maxRedemptions,
  startDateTime,
  endDateTime,
  status,
  mediaSource,
  campaign,
  entitlementDuration,
  revenuecatEntitlementEndDateTime,
  group,
}: CouponApiData) => {
  return axiosInstance.post(`/api/coupon/create`, {
    title,
    code,
    appleCouponCode,
    googleCouponCode,
    maxRedemptions,
    startDateTime,
    endDateTime,
    status,
    mediaSource,
    campaign,
    entitlementDuration,
    group,
    revenuecatEntitlementEndDateTime,
  })
}

const createCouponsGroup = ({
  title,
  code,
  appleCouponCode,
  googleCouponCode,
  entitlementDuration,
  quantity,
  maxRedemptions,
  startDateTime,
  endDateTime,
  status,
  mediaSource,
  campaign,
  revenuecatEntitlementEndDateTime,
}: CouponApiData) => {
  return axiosInstance.post(`/api/coupon/create-list`, {
    title,
    code,
    appleCouponCode,
    googleCouponCode,
    maxRedemptions,
    startDateTime,
    endDateTime,
    status,
    mediaSource,
    campaign,
    entitlementDuration,
    quantity,
    revenuecatEntitlementEndDateTime,
  })
}

const deleteCoupon = (couponId) => {
  return axiosInstance.delete(`/api/coupon/${couponId}`)
}

const couponApi = {
  getAllCoupons,
  createCoupon,
  deleteCoupon,
  createCouponsGroup,
}

export default couponApi
